import { appConstants } from 'constants/index';
const { SALE_PORTAL_BFF } = appConstants;

export enum ERole {
  administrator = 'administrator',
  saleManager = 'sale-manager',
  saleAdmin = 'sale-admin',
  teamLead = 'team-lead',
  sale = 'sale',
  collaborator = 'collaborator',
  network = 'network',
  allTicketImplementation = 'all-ticket-implementation',
}

export const RoleIAM = {
  allTicketImplementation: `${SALE_PORTAL_BFF}:all-ticket-implementation`,
  implementTicket: `${SALE_PORTAL_BFF}:implementation-ticket`,
};

export const ROLE_TITLE_GET_STAFF = {
  all: 0,
  administrator: 1,
  saleManager: 2,
  saleAdmin: 3,
  teamLead: 4,
  sale: 5,
  appraiser: 6,
};
